import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import DashboardNav from '@/components/DashboardNav';
import GamificationPanel from '@/components/GamificationPanel';

export default function ProgressPage() {
  const { user } = useAuth();

  if (!user) return null;

  return (
    <div className="min-h-screen bg-slate-50" data-testid="progress-page">
      <DashboardNav />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h2 className="text-2xl font-black text-slate-800 mb-6" style={{ fontFamily: 'Montserrat' }}>
          Insignias
        </h2>
        <GamificationPanel studentId={user.id} badgesOnly={true} />
      </main>
    </div>
  );
}
